import BaseRequest from './BaseRequest';

const schema = 'campaign';
/**
 * key base on host:port
 */
export default class CampaignRequest extends BaseRequest {
  /**
   *
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  fetchAllCampaign(params) {
    const url = `${schema}/paginate`;
    return this.get(url, params);
  }

  addCampaign(params) {
    const url = `${schema}`;
    return this.post(url, params);
  }

  updateCampaign(params) {
    const url = `${schema}`;
    return this.put(url, params);
  }

  updateCampaignConfig(data) {
    const url = `${schema}/config`;
    return this.put(url, data);
  }

  deleteCampaign(params) {
    const url = `${schema}/${params.bid}`;
    return this.del(url, params);
  }
}
